/** Badge colors shared by eligibility worklists and patient details. */
export interface EligibilityStatusBadgeColors {
  backgroundColor: string;
  textColor: string;
}

/**
 * Resolve design-token colors for an eligibility status badge.
 *
 * @param status - Eligibility status returned by the API or its display label
 * @returns Shared background and text colors for the status
 */
export function getEligibilityStatusBadgeColors(
  status: string | null | undefined,
): EligibilityStatusBadgeColors {
  const normalized = (status || "").toLowerCase();
  if (normalized.includes("ineligible")) {
    return { backgroundColor: "#FEE2E2", textColor: "#B91C1C" };
  }
  if (normalized.includes("eligible")) {
    return { backgroundColor: "#E2F2ED", textColor: "#08735A" };
  }
  if (normalized.includes("hold")) {
    return { backgroundColor: "#FFEDD5", textColor: "#C2410C" };
  }
  if (normalized.includes("pending")) {
    return { backgroundColor: "#FEF9C3", textColor: "#854D0E" };
  }
  return { backgroundColor: "#F3F4F6", textColor: "#374151" };
}
